if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
			
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}


document.addEventListener('DOMContentLoaded', function () {
  const datePickerWrapper = document.getElementById('custom-date-picker-wrapper');
  let hiddenInput = document.getElementById('final-delivery-date');
  let datePicker = document.getElementById('custom-date-picker');
  const deliverySelector = document.querySelector('.delivery-date-selector');

  let warningText = document.createElement('p');
  warningText.textContent = "Lütfen gönderim günü seçin.";
  warningText.style.color = "red";
  warningText.style.marginTop = "8px";
  warningText.style.fontSize = "14px";
  warningText.id = "delivery-warning";

  document.querySelectorAll('input[name="delivery_choice"]').forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.value === "custom") {
        datePickerWrapper.style.display = 'block';
        hiddenInput.value = "";

        // ✅ Tarih Seçiciyi Sıfırla ve 2 Gün Sonradan Başlat
        datePicker.replaceWith(datePicker.cloneNode(true));
        datePicker = document.getElementById('custom-date-picker');

        const today = new Date();
        const twoDaysLater = new Date(today.getTime() + (2 * 24 * 60 * 60 * 1000)); // 2 gün sonrası
        const formattedMinDate = twoDaysLater.toISOString().split("T")[0];
        datePicker.setAttribute("min", formattedMinDate);
        datePicker.value = formattedMinDate; // Varsayılan olarak 2 gün sonrası göster

        datePicker.addEventListener('change', function () {
          if (datePicker.value !== "") {
            const selectedDate = new Date(datePicker.value);
            const formattedDate =
              ("0" + selectedDate.getDate()).slice(-2) + "." +
              ("0" + (selectedDate.getMonth() + 1)).slice(-2) + "." +
              selectedDate.getFullYear();

            hiddenInput.value = "Teslimat Günü - " + formattedDate;
            removeWarning();
          }
        });

      } else {
        datePickerWrapper.style.display = 'none';
        hiddenInput.value = this.value;
        removeWarning();
      }
    });
  });

  const addToCartButton = document.querySelector('form[action*="/cart/add"] [type="submit"]');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function (e) {
      const selectedOption = document.querySelector('input[name="delivery_choice"]:checked');

      if (!selectedOption || (selectedOption.value === "custom" && hiddenInput.value === "")) {
        e.preventDefault();
        deliverySelector.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (!document.getElementById('delivery-warning')) {
          deliverySelector.appendChild(warningText);
        }
        return false;
      }

      // ✅ Son Kontrol: Teslimat tarihi boşsa, form gönderilmesin
      if (!hiddenInput.value || hiddenInput.value === "") {
        e.preventDefault();
        deliverySelector.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (!document.getElementById('delivery-warning')) {
          deliverySelector.appendChild(warningText);
        }
        return false;
      }
    });
  }

  function removeWarning() {
    const existingWarning = document.getElementById('delivery-warning');
    if (existingWarning) {
      existingWarning.remove();
    }
  }
});

